import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../service/auth.service';

// The login call has no token yet, and its own 401 (bad credentials) is handled locally by
// LoginComponent — routing it through the same redirect-to-/login logic below would just
// bounce the user back to the page they're already on.
function isLoginRequest(url: string): boolean {
  return url === environment.login.apiEndpoint;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isLoginRequest(req.url)) {
    return next(req);
  }

  const token = authService.getToken();
  const authReq = token ? req.clone({ setHeaders: { 'x-auth-token': token } }) : req;

  return next(authReq).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        authService.clearSession();
        router.navigate(['/login'], { queryParams: { redirectUrl: router.url } });
      }
      return throwError(() => error);
    }),
  );
};
